<!-- EvaluationTableRow.vue -->
<template>
    <div class="d-flex justify-content-center">
        <b-button variant="success" class="m-2 text-white" style="min-width: 200px;"
            @click="seminarEvaluationTable()">
            Update Score
        </b-button>

        <b-modal id="importExcelModel" size="xl" v-model="viewImportExcelModel" title="Import Excel for Scores" hide-footer>
            <SeminarExcelImport
                :importExcelFile="importExcelFile"
                :excelImportStatus="excelImportStatus"
                @import="importScoreExcel"
            />
        </b-modal>

        <b-modal modal-class="seminarEvaluation" id="seminarEvaluationModel" show no-close-on-backdrop
            no-close-on-keyboard no-close-on-esc hide-header-close hide-header hide-footer>
            <b-col>
                <div class="d-flex justify-content-start align-items-center mb-3">
                    <b-button variant="primary" class="mr-2" v-b-modal.importExcelModel>
                        Import Excel
                    </b-button>
                    <b-button @click="updateSeminarEvaluation()" :disabled="updateSeminarEvaluationButton != 'Save'" variant="primary"
                        class="mr-2">
                        {{ updateSeminarEvaluationButton }}
                    </b-button>
                    <b-button @click="closeSeminarEvaluationModel()" variant="danger">
                        Cancel
                    </b-button>
                </div>
                <table class="table table-striped table-bordered">
                    <thead style="position: sticky; top: 0; background-color: gray;">
                        <tr>
                            <th rowspan="3">No.</th>
                            <th rowspan="3">Student</th>
                            <th v-for="(method, methodIndex) in evaluationMethods" :key="methodIndex"
                                :colspan="method.parameters.length + 1">
                                <span v-b-tooltip.hover :title="method.name">{{ method.name }}</span>
                            </th>
                            <th rowspan="3">Total Score</th>
                            <th rowspan="3">Avg</th>
                        </tr>
                        <tr>
                            <th v-for="(parameter, paramIndex) in evaluationTableHeaderRow" :key="paramIndex">
                                {{ parameter.name }} - {{ parameter.max_score }}
                            </th>
                        </tr>
                        <tr>
                            <th v-for="(parameter, paramIndex) in evaluationTableHeaderRow" :key="paramIndex">
                                {{ Array.isArray(parameter.cos) ? parameter.cos.join(', ') : parameter.cos }}
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(student, studIndex) in students" :key="studIndex">
                            <th class="fixed-table-column">{{ student.roll_number }}</th>
                            <th class="fixed-table-column">{{ student.first_name }} {{ student.last_name }}</th>

                            <td v-for="(evaluationHeader, headIndex) in evaluationTableHeaderRow" :key="headIndex"
                                style="min-width: 60px;">
                                <b-form-input v-if="evaluationHeader.type == null"
                                    v-model="evaluationTableData[student.institution_user_id][evaluationHeader.seminar_method_id][evaluationHeader.id]"
                                    type="number" :max="evaluationHeader.max_score" placeholder="Enter score"
                                    @focus="handleScoreInputFocus(student.institution_user_id, evaluationHeader.seminar_method_id, evaluationHeader.id)"
                                    @change="updateTotalMarks(student.institution_user_id, evaluationHeader.seminar_method_id)">
                                </b-form-input>

                                <span v-if="evaluationHeader.type == 'total'">
                                    {{ totalScores[student.institution_user_id][evaluationHeader.seminar_method_id] }}
                                </span>
                            </td>

                            <!-- ✅ New Total Score Column -->
                            <th class="fixed-table-column">
                                {{ grandTotal[student.institution_user_id] || 0 }}
                            </th>

                            <th class="fixed-table-column">
                                {{ avarage[student.institution_user_id]
                                        ? Number(avarage[student.institution_user_id]).toFixed(2)
                                        : 0
                                }}
                            </th>
                        </tr>
                    </tbody>
                </table>

                <b-button @click="updateSeminarEvaluation()" :disabled="updateSeminarEvaluationButton != 'Save'"
                    variant="primary">
                    {{ updateSeminarEvaluationButton }}
                </b-button>
                <b-button class="ml-4" @click="closeSeminarEvaluationModel()" variant="danger">Cancel</b-button>
            </b-col>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from "axios";
import SeminarExcelImport from './SeminarExcelImport.vue';
import readXlsxFile from "read-excel-file";

export default {
    props: {
        evaluationMethods: { type: Array, required: true },
        course_id: { type: Number, required: true }
    },
    components: {
        SeminarExcelImport
    },

    data() {
        return {
            viewImportExcelModel: false,
            importExcelFile: null,
            excelImportStatus: "",
            evaluationTableHeaderRow: [],
            evaluationTableData: {},
            students: [],
            totalScores: {},
            grandTotal: {}, // ✅ Added
            avarage: {},
            updateSeminarEvaluationButton: "Save",
            scoreEntryCount: new Set(),
            autoUpdation: false,
        };
    },

    methods: {
        async importScoreExcel(event) {
            this.excelImportStatus = "Importing in progress...";
            try {
                const excelData = await readXlsxFile(event.target.files[0]);
                if (!excelData || excelData.length === 0) throw new Error("The Excel file is empty.");

                if (excelData.length > this.students.length)
                    throw new Error(`The Excel file has more rows (${excelData.length}) than students (${this.students.length}).`);

                const expectedColumns = this.evaluationTableHeaderRow.length;
                if (excelData.some(row => row.length !== expectedColumns))
                    throw new Error(`The Excel file columns don't match expected count (${expectedColumns}).`);

                excelData.forEach((row, rowIndex) => {
                    const student = this.students[rowIndex];
                    row.forEach((excelValue, colIndex) => {
                        const header = this.evaluationTableHeaderRow[colIndex];
                        if (header.type === null) {
                            if (isNaN(excelValue))
                                throw new Error(`Invalid score at Row ${rowIndex + 1}, Column ${colIndex + 1}.`);
                            this.handleScoreValue(excelValue, student.institution_user_id, header.seminar_method_id, header.id);
                        }
                    });
                });

                this.$toast.success("Seminar scores imported successfully!", { position: "top", duration: 5000 });
            } catch (error) {
                this.$toast.error(`Error: ${error.message}`, { position: "top", duration: 10000 });
            } finally {
                this.excelImportStatus = "";
                this.importExcelFile = null;
                this.viewImportExcelModel = false;
            }
        },

        handleScoreValue(excelValue, institution_user_id, seminar_method_id, headerId) {
            this.$set(this.evaluationTableData[institution_user_id][seminar_method_id], headerId, parseFloat(excelValue));
            this.updateTotalMarks(institution_user_id, seminar_method_id);
        },

        async fetchCourseStudents() {
            const url = this.$store.getters.getAPIKey.createStudent.replace("course_id", this.course_id);
            const response = await this.$axios.get(url);
            this.students = response.data[0] || [];
        },

        async seminarEvaluationTable() {
            this.evaluationTableHeaderRow = [];

            if (this.students.length === 0) await this.fetchCourseStudents();

            this.evaluationMethods.forEach((method) => {
                let sum = 0;
                method.parameters.forEach((parameter) => {
                    sum += Number(parameter.maximum_score);
                    this.evaluationTableHeaderRow.push({
                        id: parameter.id,
                        name: parameter.name,
                        seminar_method_id: method.id,
                        max_score: parameter.maximum_score,
                        cos: parameter.co_codes,
                        type: null,
                    });
                });
                this.evaluationTableHeaderRow.push({
                    id: null,
                    name: 'Total',
                    seminar_method_id: method.id,
                    max_score: sum,
                    cos: null,
                    type: 'total'
                });
            });

            this.students.forEach((student) => {
                Vue.set(this.evaluationTableData, student.institution_user_id, {});
                Vue.set(this.totalScores, student.institution_user_id, {});
                Vue.set(this.grandTotal, student.institution_user_id, 0); // ✅ Initialize
                Vue.set(this.avarage, student.institution_user_id, {});

                this.evaluationTableHeaderRow.forEach((header) => {
                    if (!this.evaluationTableData[student.institution_user_id][header.seminar_method_id]) {
                        Vue.set(this.evaluationTableData[student.institution_user_id], header.seminar_method_id, {});
                    }
                    Vue.set(this.evaluationTableData[student.institution_user_id][header.seminar_method_id], header.id, null);
                });
            });

            this.$bvModal.show("seminarEvaluationModel");

            const url = `${this.$store.getters.getAPIKey.mainAPI}/seminarevaluations/updateScore?course_id=${this.course_id}`;
            const response = await axios.get(url);
            response.data.forEach((evaluation) => {
                if (this.evaluationTableData[evaluation.student_id]) {
                    this.evaluationTableData[evaluation.student_id][evaluation.parameter.seminar_method_id][evaluation.seminar_parameter_id] = parseFloat(evaluation.score);
                    this.updateTotalMarks(evaluation.student_id, evaluation.parameter.seminar_method_id);
                }
            });

            this.$forceUpdate();
        },

        updateTotalMarks(student_id, seminar_method_id) {
            const scores = this.evaluationTableData[student_id][seminar_method_id];
            const total = Object.values(scores).reduce((sum, score) => sum + Number(score || 0), 0);
            this.totalScores[student_id][seminar_method_id] = total;

            // Compute overall total of all seminar totals
            const allTotals = Object.values(this.totalScores[student_id]).filter(score => score);
            const grandTotal = allTotals.reduce((a, b) => a + b, 0);
            this.grandTotal[student_id] = grandTotal;

            // Compute average from individual seminar totals
            this.avarage[student_id] = allTotals.length
                ? (grandTotal / allTotals.length).toFixed(2)
                : 0;
        },

        async handleScoreInputFocus(student_id, seminar_method_id, parameter_id) {
            const key = `${student_id}-${seminar_method_id}-${parameter_id}`;
            this.scoreEntryCount.add(key);

            if (this.scoreEntryCount.size == 20) {
                this.autoUpdation = true;
                await this.updateSeminarEvaluation();
            }
        },

        closeSeminarEvaluationModel() {
            this.$bvModal.hide("seminarEvaluationModel");
        },

        async updateSeminarEvaluation() {
            const postData = [];

            Object.entries(this.evaluationTableData).forEach(([student_id, methods]) => {
                Object.entries(methods).forEach(([seminar_method_id, parameters]) => {
                    Object.entries(parameters).forEach(([seminar_parameter_id, score]) => {
                        if (score !== null) {
                            postData.push({
                                score,
                                course_id: this.course_id,
                                student_id,
                                seminar_method_id,
                                seminar_parameter_id,
                            });
                        }
                    });
                });
            });

            try {
                await axios.post(
                    `${this.$store.getters.getAPIKey.mainAPI}/seminarevaluations/updateScore`,
                    { seminarEvaluations: postData }
                );
                if (this.autoUpdation) {
                    this.scoreEntryCount.clear(); 
                    this.$toast.success("Automatically updated successfully.", { position: "top", duration: 3000 });
                    this.autoUpdation = false;
                } else {
                    this.$toast.success("Successfully Updated", { position: "top", duration: 3000 });
                    this.$bvModal.hide("seminarEvaluationModel");
                }
            } catch (error) {
                this.$toast.error("Failed to update", { position: "top", duration: 3000 });
            }
        },
    },
};
</script>

<style>
.seminarEvaluation .modal-dialog {
  max-width: 100%;
  max-height: 100vh;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  position: fixed;
  z-index: 100000;
}

.seminarEvaluation .modal-body {
  overflow: scroll;
}

.seminarEvaluation .fixed-table-column {
  position: sticky;
  left: 0;
  background-color: gray;
}
</style>
